import { get } from "lodash";
import { StoreState } from "./types";

export const selectUserToken = (state: StoreState): string | null => {
  return get(state, "user.token", null);
};
